// apps/client/src/ui/kit/Tabs.tsx
/** `tight`: narrower pills that keep to one row (a few short choices in a narrow column, e.g. the settings' graphics quality). */
export function Tabs(p: { tabs: readonly { id: string; label: string }[]; active: string; onChange: (id: string) => void; tight?: boolean }) {
  return (
    <div className={p.tight ? 'tabs tabs--tight' : 'tabs'} role="tablist">
      {p.tabs.map((tab) => <button key={tab.id} type="button" role="tab" className="tab" aria-selected={tab.id === p.active} onClick={() => p.onChange(tab.id)}>{tab.label}</button>)}
    </div>
  );
}
